import ArrowScrollSvg from './ArrowScrollSvg';

type IsAbleToScrollIndicatorProps = {
    indexInRow: number;
    rowLength: number;
    titleString?: string;
    onScroll: (newIndex: number) => void;
};

const IsAbleToScrollIndicator = ({
    indexInRow,
    rowLength,
    titleString,
    onScroll,
}: IsAbleToScrollIndicatorProps) => {
    const shouldDisplayRightArrow = indexInRow > 0;
    const shouldDisplayLeftArrow = indexInRow < rowLength - 1;

    const handleRightScroll = () => {
        if (shouldDisplayRightArrow) {
            onScroll(indexInRow - 1);
        }
    };

    const handleLeftScroll = () => {
        if (shouldDisplayLeftArrow) {
            onScroll(indexInRow + 1);
        }
    };

    return (
        <div className="w-full h-[3vw] p-0 my-[1vw] relative flex items-center">
            <div className="flex items-center gap-[1vw]">
                {titleString && (
                    <span className="text-white text-[1.7vw] font-bold">{`${titleString}`}</span>
                )}
                {shouldDisplayRightArrow && (
                    <ArrowScrollSvg direction="right" onClick={handleRightScroll} />
                )}
            </div>
            {shouldDisplayLeftArrow && (
                <div className="absolute left-[2vw]">
                    <ArrowScrollSvg direction="left" onClick={handleLeftScroll} />
                </div>
            )}
        </div>
    );
};

export default IsAbleToScrollIndicator;
